import { createAction } from "@reduxjs/toolkit";
import { BannerProps } from "../../components/banner";

export namespace BannerActions {
  export enum ActionTypes {
    setBanner = "Set Banner",
    clearBanner = "Clear Banner",
  }

  export const clearBanner = createAction(ActionTypes.clearBanner);
  export const setBanner = createAction<BannerProps>(ActionTypes.setBanner);

  export type ClearBanner = ReturnType<typeof clearBanner>;
  export type SetBanner = ReturnType<typeof setBanner>;

  export type Actions = ClearBanner | SetBanner;
}
